import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import '@/assets/theme/index.css'

import '@/assets/icon/iconfont.css'
import lodash from 'lodash'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
/*格式化时间*/
import {formatTime} from "./utils/time";

Vue.filter('format', formatTime);

//自定义指令
//element调用该指令的标签，比如<span></span>
//binding是title指令
Vue.directive('title', function (el, binding) {
    document.title = el.dataset.title
});

import store from "./store"

Object.defineProperty(Vue.prototype, '$_', {value: lodash});

Vue.use(ElementUI);
Vue.config.productionTip = false;

new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app')
